import { render, staticRenderFns } from "./puppy-for-sale-details-container.vue?vue&type=template&id=cb4fab08&scoped=true&lang=pug"
import script from "./puppy-for-sale-details-container.js?vue&type=script&lang=js&external"
export * from "./puppy-for-sale-details-container.js?vue&type=script&lang=js&external"
import style0 from "./puppy-for-sale-details-container.vue?vue&type=style&index=0&id=cb4fab08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4fab08",
  null
  
)

export default component.exports